<template>
    <div>
        <div class="result-tab-wrap">
            <div :class="['result-tab-item', trendTab === index && 'result-tab-item-act']"
                 v-for="(item, index) in tabList" @click="getSwitch('trendTab',index)" :key="index">{{ item.name }}
            </div>
        </div>
        <template v-if="tabListIndex != 2">
            <!-- 折线图 -->
            <div id="delivery"></div>
            <div class="follow-table">
                <div class="follow-table-top">
                    <div class="follow-table-top-item" v-for="(item, index) in arrType.slice(1)" :key="index">
                        {{ item.name }}
                    </div>
                </div>
                <div class="follow-table-bottom">
                    <div v-for="(item, itx) in arrType.slice(1)" :key="itx" class="follow-table-bottom-item">
                        <img v-if="item.state" src="../../../../assets/images/result/up.png" alt="">
                        <img v-else src="../../../../assets/images/result/down.png" alt="">
                        <div class="up">{{ item.num }}%</div>
                    </div>
                </div>
            </div>
            <div class="radio_content">
                <div class="radio-wrap">
                    <div class="radio-item" v-for="(item,index) in arrRabid" :key="index"
                         @click="getIsfollow('arrRabid',index)">
                        <img :src="item.open ? selectImg : noSelectImg" alt="">
                        <div>{{ item.name }}</div>
                    </div>
                </div>
                <div class="radio-wrap">
                    <div class="radio-item" v-for="(item,index) in arrYear" :key="index">
                        <!-- 隐藏同比，所以就不需要点击事件了 -->
                        <!-- <div class="radio-item" v-for="(item,index) in arrYear" :key="index" @click="getIsfollow('arrYear',index)"> -->
                        <img :src="item.open ? selectImg : noSelectImg" alt="">
                        <div>{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="seach_clty">
                <div class="pick" @click="openSelect(0)">{{ sRankTitle }}</div>
                <div class="pick_warp">
                    <div :class="[nCity == index?'atv_pick':'']" v-for="(item,index) in arrCity" :key="index"
                         @click="changeType(index,item.id)">{{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 列表 -->
            <div class="tabel">
                <div class="biao_tb">
                    <div :style="{width:index == 0?'15%':index == 1?'30%':index == 2?'35%':'20%'}"
                         v-for="(item,index) in titleList" :key="index">{{ item }}
                    </div>
                </div>
                <div v-if="nCity != 2 && nCity != 3">
                    <div class="biao_th" :style="{'height':item.filter(i => i.length>5).length != 0?'75px':'60px'}"
                         v-for="(item,index) in tableData" :key="index">
                        <div style="width:15%;">{{ item[0] }}</div>
                        <div style="width:30%;">{{ item[1] }}</div>
                        <div style="width:35%;">
                            <span>{{ item[2] }}</span>
                        </div>
                        <div style="width:20%;">{{ item[3] }}</div>
                    </div>
                </div>
                <div v-if="nCity == 2 || nCity == 3">
                    <div class="biao_th" :style="{'height':item.filter(i => i.length>5).length != 0?'80px':'60px'}"
                         v-for="(item,index) in tableData" :key="index">
                        <div style="width:15%;">{{ item[0] }}</div>
                        <div style="width:30%;">{{ item[1] }}</div>
                        <div style="width:35%;">
                        <span>
                            {{ item[2] }}
                            <template v-if="item[2] && item[3]">/</template>
                            {{ item[3] }}
                        </span>
                        </div>
                        <div style="width:20%;">{{ item[4] }}</div>
                    </div>
                </div>
            </div>
            <div class="page-wrap">
                <el-performance :page="nPage" :nNumber="nTotal" @next="next" @last="last" @active="getActive"
                                :bBackfoued="false"></el-performance>
            </div>
            <div class="report_time">
                <div class="tips">
                    <div>自行选择</div>
                    <div>导出时间</div>
                </div>
                <div class="time">
                    <div class="flc" @click="selectTime('start_at')">{{ reportTime.start_at }}</div>
                    <div>至</div>
                    <div class="flc" @click="selectTime('end_at')">{{ reportTime.end_at }}</div>
                </div>
            </div>
            <div class="bottom_btn">
                <div @click="getReportRankExport(2)">导出2.0数据</div>
                <div @click="getReportRankExport(3)">导出3.0数据</div>
            </div>
        </template>
        <template v-else>
            <construct></construct>
        </template>
        <van-popup round position="bottom" v-model="popShow">
            <van-picker :title="selectTitle" value-key="title" show-toolbar :columns="columns" @confirm="onConfirm"
                        @cancel="popShow = false"/>
        </van-popup>
        <van-popup round position="bottom" v-model="BselectTime">
            <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" @confirm="confirmTime"
                                 :min-date="minDate" :max-date="maxDate"/>
        </van-popup>


        <van-popup
            v-model="weelyShow"
            position="bottom"
            custom-style="height: 20%;"
            @close="weelyClose"
        >
            <changWeely :defaults="defaults" @onConfirm="onConfirm"/>
        </van-popup>
    </div>
</template>
<script>
import elPerformance from "@/components/common/pagination/index.vue";
import resultRequest from '@/js/hvac/performance/result.js';
import Timer from './experience.vue';
import {fetchVerifyAuthForB} from '@/libsV2/havc.js'
import construct from './construct'
import changWeely from './selectweek'

export default {
    components: {
        changWeely,
        elPerformance,
        Timer,
        construct
    },
    props: {
        timestr: {
            type: String,
            default: '000'
        }
    },
    data() {
        return {
            weelyShow: false, //选择周
            minDate: new Date(2012, 0, 1),
            maxDate: new Date(2030, 10, 1),
            reportTime: {
                end_at: '',
                start_at: ''
            },//一键导出的时间对象
            currentDate: '',//默认时间
            BselectTime: false,//默认选中时间
            selectTimeType: '',//开始还是结束的时间

            popShow: false,
            selectTitle: '',
            nTrendItem: 0,
            selectImg: require("@/assets/images/result/select.png"),
            noSelectImg: require("@/assets/images/result/noSelect.png"),
            arrCity: [
                {name: "城市", id: 0},
                {name: "代理商", id: 1},
                {name: "签单手", id: 2},
                {name: "体验间", id: 3},
            ],
            arrType: [
                {name: '用户邀约', id: 1, state: true, num: 50},
                {name: '体验人次', id: 2, state: true, num: 50},
                {name: '成交单数', id: 3, state: true, num: 50},
                // {name:'竣工体验间',id:3, state: true, num: 50},
            ],
            trendTab: 0,
            nCity: 0,
            columns: [],
            tabList: [
                // { name: "用户邀约" },
                {name: "体验人次"},
                {name: "成交单数"},
                {name: "竣工体验间"},
            ],
            tabListIndex: 0,  // 下标
            defaults: '',

            arrRabid: [
                {name: "月", open: true, item: "money"},
                {name: "周", open: false, item: "project"},
                {name: "日", open: false, item: "client"},
            ],
            arrYear: [
                // { name: "同比", open: true, ratio: "same" },
                {name: "环比", open: true, ratio: "ring"},
            ],
            sRankTitle: "体验排名",
            nPage: 1,
            nTotal: 0,
            start_at: this.currentTime(),
            end_at: this.newDate(1),
            page: 0,
            limit: 5,
            rank_type: 0,
            type: 0,
            tableData: [],
            titleList: [],
            appoint: {},//运营情况
            store: {},//现场体验
            contract: {},//成交体验
            showObj: {},//echarts显示


            objSate: {      // echarts 参数
                time_type: 0,
                compare_type: 1,
            },

            times: '',    // 定时器
        };
    },
    created() {
    },
    mounted() {
        console.log(this.currentData, 'mounted')
        fetchVerifyAuthForB(() => {
            this.type = 0;
            this.getReportStatistics(this.currentData)
            this.getReportRank();

            this.getCurrentData()

            this.times = setInterval(() => {  // 定时更新数据
                this.getReportStatistics(this.currentData)
                this.getReportRank();
            }, 1000 * 60 * 5);
        });
    },
    watch: {
        currentData: {
            handler(newObj, oldObj) {
                console.log(newObj, 'watch')
                // const { start_at, end_at } = newObj;
                // let parems = { start_at, end_at };
                this.getReportStatistics(newObj);
                this.changeType(0, 0)
            },
            immediate: false,
        },

    },
    methods: {
        weelyClose() {
        },
        // 设置进入默认选中时间
        getCurrentData() {
            const date = new Date();
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day
            let time = `${year}-${month}-${day}`
            this.currentDate = new Date(year, month - 1, day)
            this.$set(this.reportTime, 'start_at', time)
            this.$set(this.reportTime, 'end_at', time)
        },
        // 确定选择时间
        confirmTime(date) {
            const selectDate = new Date(date)
            const year = selectDate.getFullYear()
            let month = selectDate.getMonth() + 1
            let day = selectDate.getDate()
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day
            const time = `${year}-${month}-${day}`
            if (this.selectTimeType == 'start_at') {
                this.$set(this.reportTime, 'start_at', time)
                this.minDate = new Date(year, month - 1, day)
            } else {
                this.$set(this.reportTime, 'end_at', time)
                this.maxDate = new Date(year, month - 1, day)
            }
            this.BselectTime = false
        },
        // 选择时间触发的函数
        selectTime(type) {
            this.selectTimeType = type
            this.BselectTime = true
            if (type == 'start_at') {
                this.minDate = new Date(2012, 0, 1)
            } else {
                this.maxDate = new Date(2030, 10, 1)
            }
        },
        // 一键导出触发的函数
        getReportRankExport(num) {
            const {start_at, end_at} = this.reportTime;
            if (num == 2) {
                resultRequest.getReportExcFeed({end_at, start_at}).then(res => {
                    window.location.href = res.data.data.result.url;
                    // window.open(res.data.data.result.url, '_blank');
                })
            } else {
                resultRequest.getReportExc({end_at, start_at}).then(res => {
                    window.location.href = res.data.data.result.url;
                    // window.open(res.data.data.result.url, '_blank');
                })
            }
        },
        changeType(index, id) {
            console.log(index, id, '8888')

            this.nPage = 1;
            this.page = 0;

            this.type = id
            this.nCity = index
            let type = ''
            if (index == 0) {
                type = 'city'
            } else if (index == 1) {
                type = 'area'
            } else {
                type = 'company'
            }
            this.getReportRank(type)
        },
        // 打开选择器
        openSelect(index) {
            this.curSelect = index;
            switch (index) {
                case 0:
                    this.selectTitle = "选择排名";
                    this.columns = [
                        // { title: "邀约排名", id: 0 },
                        {title: "体验排名", id: 1},
                        {title: "成交排名", id: 2},
                    ];
                    this.popShow = true;
                    break;
            }
            ;
        },
        // 获取洽谈统计数据
        getReportStatistics(obj) {
            if (!obj.start_at) {
                // 获取当前年份
                // 写死开始时间为2021-01-01
                obj.start_at = this.currentTime();

                obj.end_at = this.newDate(0);
            }
            console.log(obj.start_at, 'obj.start')
            const options = {
                ...obj,
                ...this.objSate
            }
            resultRequest.getReportStatistics(options).then(res => {
                const market = res.data.data.result.market
                console.log(market, 'market')
                let appoint_cur = []
                let appoint_time = []
                let appoint_compare = []

                let newArr = [];
                for (let i in market) {
                    newArr.push({[i]: market[i]})
                }
                console.log(newArr, 'newArr')
                newArr.forEach((item, index) => {
                    // console.log(Object.values(item)[0].percent, 'Object.values(item)[0].percent')
                    let percent = Number(Object.values(item)[0].percent.split(',').join(''))
                    // console.log(percent,'percent')
                    this.arrType[index].num = Math.abs(percent).toFixed(1)
                    if (percent > 0) {
                        this.arrType[index].state = true;
                    } else {
                        this.arrType[index].state = false;
                    }
                    // if (Number(Object.values(item)[0].compare.total) > Number(Object.values(item)[0].cur.total)) {
                    //     // console.log(Object.values(item)[0].compare.total, Object.values(item)[0].cur.total,'Object.values(item)[0].compare.total > Object.values(item)[0].cur.total')
                    //     // console.log(Object.values(item)[0].cur.total,'totalcur2222')
                    //     // console.log(Object.values(item)[0].compare.total,'totalcompare2222')
                    //     if (Object.values(item)[0].cur.total == 0) {
                    //         this.arrType[index].num = (Object.values(item)[0].compare.total) * 100;
                    //     } else {
                    //         console.log(Object.values(item)[0].cur.total, 'totalcur')
                    //         console.log(Object.values(item)[0].compare.total, 'totalcompare')
                    //         this.arrType[index].num = ((Number(Object.values(item)[0].compare.total) - Number(Object.values(item)[0].cur.total)) / Number(Object.values(item)[0].compare.total)).toFixed(2);
                    //         console.log(this.arrType[index].num, 'false')
                    //     }
                    //     // if ()
                    //     this.arrType[index].state = false;
                    // } else if (Number(Object.values(item)[0].compare.total) < Number(Object.values(item)[0].cur.total)) {
                    //     // console.log(Object.values(item)[0].compare.total,Object.values(item)[0].cur.total,'Object.values(item)[0].cur.total')
                    //     // console.log((Object.values(item)[0].compare.total / Object.values(item)[0].cur.total).toFixed(2),'Object.values(item)[0].cur.total2')
                    //     if (Object.values(item)[0].compare.total == 0) {
                    //         this.arrType[index].num = (Object.values(item)[0].cur.total) * 100
                    //     } else {
                    //         this.arrType[index].num = ((Number(Object.values(item)[0].cur.total) - Number(Object.values(item)[0].compare.total)) / Number(Object.values(item)[0].compare.total)).toFixed(2) * 100;
                    //         console.log(Number(Object.values(item)[0].cur.total), ' true')
                    //         console.log(Number(Object.values(item)[0].compare.total), ' true2')
                    //     }
                    //     this.arrType[index].state = true;
                    // } else {
                    //     this.arrType[index].num = 0;
                    //     this.arrType[index].state = true;
                    // }
                });
                market.appoint['cur'].list.forEach(item => {
                    appoint_cur.push(item.num)
                    // appoint_cur.push(Math.ceil(Math.random()*10))
                    let time = item.time.split('-').join('/')
                    appoint_time.push(time)
                })
                market.appoint['compare'].list.forEach(item => {
                    appoint_compare.push(item.num)
                })
                this.appoint = {
                    cur: appoint_cur,
                    compare: appoint_compare,
                    time: appoint_time
                }

                let store_time = []
                let store_compare = []
                let store_cur = []
                market.store['cur'].list.forEach(item => {
                    let time = item.time.split('-').join("/")
                    store_time.push(time)
                    store_cur.push(item.num)
                    // store_cur.push(Math.ceil(Math.random()*10))
                })
                market.store['compare'].list.forEach(item => {
                    store_compare.push(item.num)
                })
                this.store = {
                    cur: store_cur,
                    compare: store_compare,
                    time: store_time
                }

                let contract_time = []
                let contract_cur = []
                market.contract['cur'].list.forEach(item => {
                    // let time = ''
                    // if (item.time.split('-')[1].substring(0,1) == 0 ){
                    //     time += item.time.split('-')[1].substring(1,2) + '月'
                    // } else {
                    //     time += item.time.split('-')[1] + '月'
                    // }
                    // if (item.time.split('-')[2].substring(0,1) == 0) {
                    //    time += item.time.split('-')[2].substring(1,2) + '日'
                    // }else {
                    //    time += item.time.split('-')[2] + '日'
                    // }
                    const time = item.time.split('-').join('/')
                    contract_time.push(time)
                    // contract_cur.push(Math.ceil(Math.random()*10))
                    contract_cur.push(item.num)
                })
                let contract_compare = []
                market.contract['compare'].list.forEach(item => {
                    contract_compare.push(item.num)
                })
                this.contract = {
                    cur: contract_cur,
                    compare: contract_compare,
                    time: contract_time,
                }

                // this.showObj = this.appoint
                this.getSwitch('trendTab', this.tabListIndex);
            })
        },
        /**
         *根据数据条数与每页多少条数据计算页数 
         * totalnum 数据条数
         * limit 每页多少条
         */
        pageCount(totalnum, limit) {
            return totalnum > 0 ? ((totalnum < limit) ? 1 : ((totalnum % limit) ? (parseInt(totalnum / limit) + 1) : (
                totalnum / limit))) : 0;
        },
        // 获取洽谈排名数据
        getReportRank() {
            let start_time = '';
            let end_time = '';
            if (!this.currentData.start_at) {
                start_time = '2021-01-01';
                end_time = this.newDate(0);
            } else {
                const {start_at, end_at} = this.currentData;
                start_time = start_at;
                end_time = end_at;
            }


            this.tableData = [];
            const options = {
                start_at: start_time,
                end_at: end_time,
                page: this.page,
                limit: this.limit,
                rank_type: this.rank_type,
                type: this.type
            }
            resultRequest.getReportRank(options).then(res => {
                let result = res.data.data.result;
                this.tableData = result.list
                this.nTotal = this.pageCount(result.total, this.limit);
                this.titleList = result.title
            })
        },
        onConfirm(val) {

            console.log(val, '9999')
            this.sRankTitle = val.title;
            this.popShow = false;

            this.nPage = 1;
            this.page = 0;
            this.rank_type = val.id;

            if (val.id == 3) {
                this.arrCity = [
                    {name: "城市", id: 0},
                    {name: "代理商", id: 1}
                ];
                this.type = 0;
                this.nCity = 0;
            } else {
                this.arrCity = [
                    {name: "城市", id: 0},
                    {name: "代理商", id: 1},
                    {name: "签单手", id: 2},
                    {name: "体验间", id: 3}
                ];
            }


            this.getReportRank();
        },
        getIsfollow(type, num) {
            if (type == 'arrRabid') {    // 更改时间类别
                this.objSate.time_type = num;
            } else if (type == 'arrYear') {
                this.objSate.compare_type = num;
            }
            this.getReportStatistics(this.currentData);

            let _that = this;
            _that[type].forEach((it, index) => {
                if (num == index) {
                    it.open = true;
                } else {
                    it.open = false;
                }
            });
        },
        getSwitch(type, num) {
            this.tabListIndex = num;
            let _that = this;
            switch (type) {
                case "trendTab":
                    //业绩趋势
                    //预重复点击
                    if (_that[type] != num) {
                        _that[type] = num;
                    }

                    if (num == 0) {
                        // this.showObj = this.appoint
                        this.showObj = this.store
                    } else if (num == 1) {
                        // this.showObj = this.store
                        this.showObj = this.contract
                    } else if (num == 2) {
                        // this.showObj = this.contract
                        // this.$emit('showOther')
                        console.log(this.tabListIndex, 'tabListIndex')
                        return
                    }
                    this.$nextTick(() => {
                        this.createDeliveryLine();
                    })
                    // var option = this.$echarts.init(document.getElementById("delivery")).getOption();
                    // option.series[0].data = this.showObj.compare;
                    // option.series[1].data = this.showObj.cur;
                    // this.$echarts.init(document.getElementById("delivery")).setOption(option);
                    break;
            }
        },
        currentTime() {
            const nowdate = Date.parse(new Date())
            let newDate = new Date(nowdate - 60 * 60 * 24 * 1000 * 1);
            const year = newDate.getFullYear() - 1;
            return `${year}-01-01`;
        },
        newDate(i) {
            const nowdate = Date.parse(new Date())
            let newDate = new Date(nowdate - 60 * 60 * 24 * 1000 * i);
            const year = newDate.getFullYear();
            let month = newDate.getMonth() + 1;
            let date = newDate.getDate();
            month = (month < 10) ? '0' + month : month
            date = (date < 10) ? '0' + date : date
            const time = year + '-' + month + '-' + date
            return time
        },
        createDeliveryLine() {
            var zoomend = 100;
            if (this.showObj.cur.length > 6) {
                zoomend = 100 / (Math.ceil(this.showObj.cur.length / 7));
            }
            const CHARTS = this.$echarts.init(
                document.getElementById("delivery")
            );
            let start_time = '';
            let end_time = '';
            if (!this.currentData.start_at) {
                start_time = '2021-01-01';
                end_time = this.newDate(0);
            } else {
                const {start_at, end_at} = this.currentData;
                start_time = start_at;
                end_time = end_at;
            }

            console.log(this.showObj, '88888')
            const OPTIONS = {
                title: {
                    text: `${start_time} ~ ${end_time}`,
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: "#999999",
                        fontSize: 12
                    }
                },
                grid: {
                    y: "19%",
                    y2: "22%",
                },
                dataZoom: [
                    {
                        type: "inside",//slider表示有滑动块的，
                        show: true,
                        xAxisIndex: [0],//表示x轴折叠
                        // start:0,//数据窗口范围的起始百分比,表示1%
                        // end: zoomend,//数据窗口范围的结束百分比,表示35%坐标
                        start: 100 - zoomend,//数据窗口范围的起始百分比,表示1%
                        end: 100,//数据窗口范围的结束百分比,表示35%坐标
                        height: '5%',
                        bottom: '2%',
                    }
                ],
                // legend:{
                //     left:'center'
                // },
                color: ["#4F84EC", "#65BAC3"],
                xAxis: {
                    type: "category",
                    data: this.showObj.time,
                    axisLabel: {
                        interval: 0,
                        margin: 8,
                        rotate: 65,
                        inside: false,
                        textStyle: {
                            color: '#000',
                            fontSize: '10',
                            itemSize: ''
                        },
                        formatter: (value, index) => {
                            if (this.objSate.time_type == 1) {
                                return value + "周";
                            } else {
                                return value;
                            }
                        },
                    },
                },
                yAxis: [
                    // type: "value",
                    // axisLine: {
                    //     //y轴
                    //     show: false,
                    // },
                    // axisTick: {
                    //     //y轴刻度线
                    //     show: false,
                    // },
                    //
                    // splitArea: {//坐标轴在grid区域中的分隔区域（间隔显示网格区域）
                    //     interval: 1, //显示间隔的规律
                    //     show: true,
                    //     areaStyle: {//分隔区域的样式
                    //         color: ['rgba(255,255,255,0.03)', 'rgba(255,255,255,0)']
                    //     }
                    // },

                    {
                        type: 'value',
                        minInterval: 1,
                        axisLine: {
                            show: false,
                            lineStyle: {
                                type: 'solid',
                                width: '1'//坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {}
                        },
                        axisTick: false,
                        splitLine: {  //坐标轴在grid区域中的分隔线（网格中的横线）
                            show: true,
                            lineStyle: {
                                color: ['#5A5A5A'],
                                width: 1,
                                type: 'solid',
                            }
                        },
                        splitArea: {//坐标轴在grid区域中的分隔区域（间隔显示网格区域）
                            interval: 1, //显示间隔的规律
                            show: true,
                            areaStyle: {//分隔区域的样式
                                color: ['rgba(255,255,255,0.03)', 'rgba(255,255,255,0)']
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "当期",
                        data: this.showObj.cur,
                        type: "line",
                    },

                    // {
                    //     name: "环比",
                    //     data: this.showObj.compare,
                    //     type: "line",
                    // },
                ],
            };
            CHARTS.setOption(OPTIONS);
        },
        next(val) {  // 上一页
            this.nPage = val;
            this.page = val - 1;
            this.getReportRank();
        },
        last(val) {  // 下一页
            this.nPage = val;
            this.page = val - 1;
            this.getReportRank();
        },
        getActive(val) {
            this.nPage = val;
            this.page = val - 1;
            this.getReportRank();
        }
    },
    computed: {
        currentData() {
            return this.$store.state.performanceExperience.currentData
        }
    },
    beforeDestroy() { //在vue实例销毁前，清除定时器
        if (this.times) {
            clearInterval(this.times);
        }
    }
};
</script>
<style lang="scss" scoped>
.tabel {
    width: 100%;
    border: 2px solid #e1e1e1;
    margin-top: 62px;

    .biao_th {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e1e1e1;

        div {
            word-break: break-word;
            color: #318544;
            height: 100%;
            font-size: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #e1e1e1;

            padding: 10px;
            box-sizing: border-box;

            &:last-child {
                border-right: 0;
            }

            span {
                display: flex;
                flex: 1;
                height: 100%;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #e1e1e1;

                &:last-child {
                    border-right: 0;
                }
            }
        }
    }

    .biao_tb {
        width: 100%;
        height: 80px;
        background: #f0f4f1;
        display: flex;
        align-items: center;

        div {
            color: #318544;
            height: 100%;
            font-size: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #e1e1e1;

            &:last-child {
                border-right: 0;
            }
        }
    }
}

#delivery {
    width: 100%;
    height: 600px;
}

.radio_content {
    display: flex;
    justify-content: space-between;
    margin-top: 28px;

    .radio-wrap {
        display: flex;
        padding: 18px 0;
        justify-content: space-around;
        align-items: center;
        border-radius: 12px;
        border: 2px solid #dbdbdb;

        &:last-child {
            width: 38%;
        }

        &:first-child {
            width: 60%;
        }

        .radio-item {
            display: flex;
            align-items: center;

            img {
                width: 36px;
                height: 36px;
                margin-right: 8px;
            }

            div {
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #444444;
                line-height: 40px;
            }
        }
    }
}

.seach_clty {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 22px;
    margin-top: 28px;
    border-top: 2px dashed #f1f1f1;

    .pick {
        width: 170px;
        height: 64px;
        background: #318544;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 24px;
        position: relative;

        &::after {
            content: "";
            display: flex;
            width: 28px;
            height: 28px;
            background: url("~@/assets/images/ant/back_icon_opiten.png") no-repeat center/100% 100%;
            // position: absolute;
            // right: 12px;
            margin-left: 12px;
        }
    }

    .pick_warp {
        display: flex;
        align-items: center;
        justify-content: center;
        // width: 440px;
        height: 64px;
        border-radius: 12px;
        border: 2px solid #dbdbdb;

        div {
            width: 100px;
            font-size: 24px;
            color: #c2c2c2;
            border-right: 1px solid #f1f1f1;
            display: flex;
            align-items: center;
            justify-content: center;

            &:last-child {
                border: 0;
            }
        }

        .atv_pick {
            color: $deepGreen;
        }
    }
}

.result-tab-wrap {
    margin-top: 28px;
    width: 100%;
    box-sizing: border-box;
    border-top: 1px solid #f7f7f7;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border: 2px solid $deepGreen;
    border-radius: 8px;
    overflow: hidden;

    .result-tab-item {
        flex: 1;
        height: 64px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: $deepGreen;
        line-height: 64px;
        text-align: center;
        border-left: 1px solid $deepGreen;

        &:first-child {
            border: 0;
        }
    }

    .result-tab-item-act {
        background: $deepGreen;
        color: #ffffff;
        border: none;
    }
}

.follow-table {
    width: 100%;
    border-radius: 12px;
    margin-top: 40px;
    overflow: hidden;

    .follow-table-top {
        width: 100%;
        display: flex;
        align-items: center;
        background: #318544;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 70px;

        .follow-table-top-item {
            width: 50%;
            border-right: 2px solid rgba(255, 255, 255, 0.15);

            &:last-child {
                border-right: none;
            }
        }
    }

    .follow-table-bottom {
        display: flex;
        align-items: center;
        border: 2px solid #6c9276;
        border-radius: 0 0 12px 12px;
        border-top: none;

        .follow-table-bottom-item {
            width: 50%;
            border-right: 2px solid #6c9276;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 32px;
                height: 32px;
                margin-right: 12px;
            }

            div {
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #318544;
                line-height: 70px;
            }

            .up {
                color: #318544;
            }

            .down {
                color: #eb6f56;
            }

            &:last-child {
                border: none;
            }
        }
    }
}

.report_time {
    width: 100%;
    display: flex;
    margin: 20px 0;
    align-items: center;

    .tips {
        width: 150px;
        font-size: 24px;
        color: #469859;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .time {
        border: solid gray 1px;
        border-radius: 15px;
        flex: 1;
        padding: 20px 0;
        display: flex;

        div:nth-child(2) {
            width: 50px;
            height: 100%;
            text-align: center;
        }

        div:nth-child(1) {
            flex: 1;
        }

        div:nth-child(3) {
            flex: 1;
        }
    }
}

.bottom_btn {
    width: 100%;
    color: #fff;
    margin-top: 32px;
    display: flex;

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        height: 92px;
        border-radius: 12px;
        background: linear-gradient(136deg, #4ea062 0%, #338444 100%);
        margin: 10px;
    }

    div:nth-child(1) {
        font-size: 24px;
        width: 168px;
    }

    div:nth-child(2) {
        flex: 1;
        //letter-spacing:10px;
    }
}

.page-wrap {
    margin: 0 auto;
    margin-top: 24px;
    overflow: hidden;
}

.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
